import Widget from "lib/widget";

class EmailApprovalWidget extends Widget {
  bind() {
    this.select = this.root.find('#email-approval-checklist-select');
    if (!this.select.length) return;

    this.checklists   = this.select.data('checklists');
    this.previewFrame = this.root.find('#email-preview-frame');
    this.previewBase  = this.select.data('previewBaseUrl');

    bindChecklistChange.call(this);
    bindModalOpen.call(this);
  }
}

let bindChecklistChange = function() {
  this.select.on('change', (e) => {
    updatePreview.call(this, e.target.value);
  });
}

let bindModalOpen = function() {
  this.root.find('#email-modal').on('show.bs.modal', (e) => {
    const trigger = e.relatedTarget;
    const checklistId = trigger && $(trigger).data('checklistId');
    if (checklistId != null && checklistId !== '') {
      this.select.val(String(checklistId));
    }
    updatePreview.call(this, this.select.val());
  });
}

let updatePreview = function(checklistId) {
  const data = this.checklists[checklistId];
  if (!data) return;

  this.root.find('#email-subject-cert-type').text(data.abbreviation);
  this.previewFrame.attr('src', `${this.previewBase}?checklist_id=${checklistId}`);
}

export default EmailApprovalWidget;
